import { useState } from "react";
import { SvgIcon, Tooltip } from "@material-ui/core";
import { ReactComponent as VideoIcon } from "../../images/youtube-access.svg";
import GuideVideoModal from "./index";
import { guideVideoData } from "./data";

// iconOnly: just the video icon, with "How it works?" as hover text and aria-label.
const GuideVideoTrigger = ({ pageKey, iconOnly = false }) => {
  const [open, setOpen] = useState(false);
  const modalData = guideVideoData.find((d) => d.key === pageKey);

  if (!modalData) return null;

  return (
    <>
      <Tooltip title={iconOnly ? "How it works?" : ""}>
        <button
          type="button"
          onClick={() => setOpen(true)}
          aria-label={iconOnly ? "How it works?" : undefined}
          className="flex items-center gap-2 text-[#0061F9] font-semibold text-sm cursor-pointer bg-transparent border-0 p-0 hover:opacity-80 transition"
        >
          <SvgIcon style={{ cursor: "pointer", transform: "scale(1.3)" }}>
            <VideoIcon />
          </SvgIcon>
          {!iconOnly && <span>How it works?</span>}
        </button>
      </Tooltip>
      {open && (
        <GuideVideoModal {...modalData} onClose={() => setOpen(false)} />
      )}
    </>
  );
};

export default GuideVideoTrigger;
